
import { BasePage } from "./BasePage";

import type { PageTemplateProps } from "./types";

// Onboarding Plan page — a single MAP widget plus a short intro. The intro
// runs the full content width so it lines up with the phase cards below it
// (2026-09-03).
export function MAP(props: PageTemplateProps) {
    return <BasePage {...props} fullWidthIntro />;
}
